module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1.5rem"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav"
  }, [(!_vm.isWapp) ? _c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('newMerchandiseListA', {
    attrs: {
      "merchList": _vm.merchdiseGroup,
      "description": 'group'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407eaa28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Promotion/Compositions.vue
// module id = 1613
// module chunks = 8